import { Options, Ref, Vue } from "vue-property-decorator";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ModalBox from '@/shared/components/modal-box/index.vue';
import { TrustAPI } from '@/shared/modules/trust-api';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import { Inject } from 'vue-property-decorator';
import { AppInsights } from '@/trust-admin-app/appInsights';
import PostcodeSearch from "@/shared/components/postcodeSearch/index.vue";
import { AppointTrustCoordinatorRequest, PracticeView, SuburbStatePostcode } from "@/shared/modules/typescript-trustapi-client/models";
import FileDragAndDrop from "@/shared/components/file-drag-and-drop/index.vue";
import ConfirmDialogue from '@/shared/components/confirm-dialogue/index.vue';

@Options({
  props: {
    // selectedEE: Object,
  },
  components: {
    ModalBox,
    LoadingIndicator,
    PostcodeSearch,
    FileDragAndDrop,
    ConfirmDialogue,
  }
})
export default class AppointTrustCoordinatorModal extends Vue {
  // private selectedEE!: any;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  @Ref('fileDropAndDrop') readonly fileDropAndDrop!: any;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private line1Text = 'Appoint Trust Coordinator';
  private suburbStatePostcode: SuburbStatePostcode = {};
  private isLoading = false;
  private fileList: Array<File> = [];
  private uploadedFileList: Array<any> = [];
  private uploading = false;
  private submitting = false;
  private submitPressed = false;

  private lawId = '';
  private firmName = '';
  private email = '';
  private address = '';
  private firstName = '';
  private lastName = '';
  private phoneNumber = null;
  private reasonForInactive = '';
  private inactive = false;

  private invalidLawIdEmail = false;
  private dirtyFields = [false, false, false, false, false, false];

  private membershipStatusTypes: any = [];
  private selectedMembershipType: any = null;
  private inEditMode = false;

  private loadingDataSet = false;
  private searchText = '';
  private isSearching = false;

  private async searchLawEmailID(): Promise<void> {
    this.isSearching = true;
    this.invalidLawIdEmail = false;
    this.apiService.LawIdApi?.apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(
      this.selectedPractice.id,
      { keyword: this.searchText }
    )
      .then((res: any) => {
        if (res) {
          this.lawId = res.data.lawId || '';
          this.email = res.data.email || '';
          this.firstName = res.data.firstName || '';
          this.lastName = res.data.surname || '';
          this.isSearching = false;
        } else {
          this.eventCtrl.emit('show-snackbar', 'error', 'No LawID found with this email');
          this.isSearching = false;
        }
      })
      .catch(err => {
        if (err.response.status === 400) {
          this.invalidLawIdEmail = true;
        } else {
          this.eventCtrl.emit('show-snackbar', 'error', 'Unable to search LawID/email: ' + err);
        }
        this.isSearching = false;
      })
  }

  private closeModal() {
    this.$emit('close');
  }

  private isFormValid(): boolean {
    return !!this.firstName && !!this.lastName && !!this.email && !!this.lawId;
  }

  private async save(): Promise<void> {
    try {
      this.submitPressed = true;
      if (!this.isFormValid()) {
        throw ('Incomplete form');
      }
      this.submitting = true;

      const body: AppointTrustCoordinatorRequest = {
        keyword: this.searchText,
        practiceId: this.selectedPractice.id,
      }
      await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body);
      this.eventCtrl.emit('show-snackbar', 'success', 'Trust Coordinator has been appointed');
      this.$emit('reloadTrustCoordinators');
      this.closeModal();
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error: ' + err);
      this.ai.trackException('Error on appointing Trust Coordinator: ' + JSON.stringify(err));
    } finally {
      this.submitting = false;
    }
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}

